import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, ArrowUpRight } from "lucide-react";
import { contact } from "../data";

export default function Contact() {
  return (
    <main data-testid="contact-page" className="pb-12">
      <section className="border-b border-ink-700 section-padding pt-24 pb-16">
        <p className="font-mono text-[11px] tracking-[0.24em] uppercase text-textmuted mb-4">
          / contact / coordinates
        </p>
        <h1 className="h-display text-5xl md:text-7xl max-w-[18ch]">
          Where to find <span className="text-signal-amber">us.</span>
        </h1>
      </section>

      <section className="section-padding py-20 grid grid-cols-1 md:grid-cols-2 grid-cells">
        {[contact.head_office, contact.branch_office].map((o, idx) => (
          <div key={o.name} className="p-10 hover-lift" data-testid={`office-${idx}`}>
            <p className="overline mb-3">{o.name}</p>
            <p className="font-display font-bold text-2xl mb-2">{o.person}</p>
            <div className="mt-6 space-y-4 font-mono text-sm text-textmuted">
              <div className="flex items-start gap-3">
                <MapPin size={14} className="text-signal-amber mt-1 flex-shrink-0" />
                <p className="leading-relaxed">{o.address}</p>
              </div>
              {o.emails &&
                o.emails.map((e) => (
                  <div key={e} className="flex items-center gap-3">
                    <Mail size={14} className="text-signal-amber flex-shrink-0" />
                    <a href={`mailto:${e}`} className="text-textmain hover:text-signal-amber transition-colors">
                      {e}
                    </a>
                  </div>
                ))}
              {o.phones.map((p) => (
                <div key={p} className="flex items-center gap-3">
                  <Phone size={14} className="text-signal-amber flex-shrink-0" />
                  <a href={`tel:${p.replace(/\s/g, "")}`} className="text-textmain hover:text-signal-amber transition-colors">
                    {p}
                  </a>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>

      <section className="section-padding py-16 border-t border-ink-700 flex flex-col md:flex-row md:items-center justify-between gap-6">
        <h2 className="h-display text-3xl md:text-4xl max-w-[22ch]">
          Prefer to send a request directly?
        </h2>
        <Link to="/enquiry" className="btn-primary" data-testid="contact-page-cta">
          Open enquiry form <ArrowUpRight size={14} />
        </Link>
      </section>
    </main>
  );
}
